
  <div class="modal-content">
   


    <div class="modal-body">
      <div class="card">
        <div class="row" *ngFor="let bank of payData.paymentOptions" >
          <div class="col-12">
            <input type="radio" [value]="bank" [(ngModel)]="selectedBank" (ngModelChange)="setPaymentMode()" [disabled]="bank.paymentNotAllowed" /> 
            <span>
              {{bank.title}} <span *ngIf="bank.balance"> ({{ 'LABELS.AVAILABLE_LIMIT' | translate}} - {{bank.balance | inrdisplay}})</span>
              <span *ngIf="bank.retrievingBalance"><ion-spinner name="dots"></ion-spinner></span>
            </span>
          </div>
        </div>
      </div>
    </div>
    
    <div class="modal-footer">

      <div class="row button-list">
        <div class="col-6" >
          <button class="btn  fis-btn" (click)="close()">
            {{ 'LABELS.CLOSE' | translate}}
          </button>
        </div>
        <div class="col-6" >
          <button class="btn  fis-btn" (click)="close()">
            {{ 'LABELS.DONE' | translate}}
          </button>
        </div>
      </div>
    </div>

  </div>

